// typescript version of
// https://github.com/algm/reactstrap-confirm/blob/master/src/components/ConfirmModal.js
import { __assign } from "tslib";
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
export var ConfirmModal = function (_a) {
    var onClose = _a.onClose, message = _a.message, title = _a.title, confirmText = _a.confirmText, cancelText = _a.cancelText, confirmColor = _a.confirmColor, cancelColor = _a.cancelColor, className = _a.className, buttonsComponent = _a.buttonsComponent, size = _a.size;
    var buttonsContent = (React.createElement(React.Fragment, null,
        cancelText && (React.createElement(Button, { color: cancelColor, onClick: function () { return onClose(false); } }, cancelText)),
        ' ',
        React.createElement(Button, { color: confirmColor, onClick: function () { return onClose(true); } }, confirmText)));
    if (buttonsComponent) {
        var CustomComponent = buttonsComponent;
        buttonsContent = React.createElement(CustomComponent, { onClose: onClose });
    }
    return (React.createElement(Modal, { size: size, isOpen: true, toggle: function () { return onClose(false); }, className: className },
        title && React.createElement(ModalHeader, { toggle: function () { return onClose(false); } }, title || null),
        React.createElement(ModalBody, null, message),
        React.createElement(ModalFooter, null, buttonsContent)));
};
ConfirmModal.defaultProps = {
    message: 'Are you sure?',
    title: 'Warning!',
    confirmText: 'Ok',
    cancelText: 'Cancel',
    confirmColor: 'primary',
    cancelColor: '',
    className: '',
    buttonsComponent: null,
    size: null
};
export var confirm = function (props) {
    return new Promise(function (resolve) {
        var el = document.createElement('div');
        var handleResolve = function (result) {
            if (el) {
                unmountComponentAtNode(el);
                el = null;
                resolve(result);
            }
        };
        render(React.createElement(ConfirmModal, __assign({}, props, { onClose: handleResolve })), el);
    });
};
//# sourceMappingURL=ConfirmModal.js.map